import { inject, Injectable, signal, Signal } from '@angular/core';
import { BrnDialogRef, BrnDialogService } from '@spartan-ng/brain/dialog';
import { AlertButtons, AlertComponent } from '../components/global/alert/alert.component';

@Injectable({ providedIn: 'root' })
export class AlertDialogService {
  
  private dialogRef!: BrnDialogRef<any> | undefined;
  private dialogService = inject(BrnDialogService);

  async open(header: string, description: string | Signal<string>, buttons: AlertButtons[], isXIconVisible = true): Promise<boolean> {
    if (this.dialogRef) this.dialogRef.close();
    if (!buttons || buttons.length === 0) {
      buttons = [
        {
          id: 'btn-alert-ok',
          text: 'OK',
          type: 'action',
          action: () => this.close(),
        },
      ];
    }
    
    const processedButtons = buttons.map((btn) => ({
      ...btn,
      action: () => {
        btn.action?.();
        this.dialogRef?.close();
      },
    }));

    this.dialogRef = this.dialogService.open(AlertComponent, undefined, {
      data: {
        header,
        description: typeof description === 'function' ? description : signal(description),
        buttons: processedButtons,
        isXIconVisible,
      },
    });

    return new Promise((resolve) => {
      this.dialogRef?.closed$.subscribe((result: any) => {
        resolve(result ?? false);
      });
    });
     
  }

  close() {
    this.dialogRef?.close();
    this.dialogRef = undefined;
  }

  isOpen(): boolean {
    return !!this.dialogRef;
  }
}
